export default __webpack_public_path__ + "static/media/no-contractors.e2b58a51.svg";